import { FormItem } from 'vnetwork-ui'
import { useFormContext, useWatch } from 'react-hook-form'
import { Typogaphy } from 'vnetwork-ui'
import { FormValues } from '..'
import countries from '@/modules/Employee/data/countries.json'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { getCities, getDitricts, getWards } from '@/modules/Employee/services'
import { useTranslation } from 'react-i18next'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface PermanentAddressProps {
    country?: string
    city_key?: keyof FormValues
    district_key?: keyof FormValues
    ward_key?: keyof FormValues
    steet_key?: keyof FormValues
    formTitle?: string
    padding?: boolean
    country_key?: keyof FormValues
    returnFullOption?: boolean
}

const PermanentAddress: React.FC<PermanentAddressProps> = ({
    country,
    city_key,
    district_key,
    ward_key,
    steet_key,
    formTitle,
    padding = true,
    country_key = 'employee_country',
    returnFullOption = false,
}) => {
    const { control, setValue } = useFormContext<FormValues>()
    const { t } = useTranslation()

    const employee_country = useWatch({
        control,
        name: country_key,
    }) as string | { value: string; label: string }

    const employee_city = useWatch({
        control,
        name: city_key || 'employee_city',
    }) as string | { value: string; label: string }

    const employee_district = useWatch({
        control,
        name: district_key || 'employee_district',
    }) as string | { value: string; label: string }

    const { data, isFetching } = useQueryWithHandler(
        {
            queryKey: [QUERY_KEYS.CITIES, formTitle, employee_country],
            queryFn: () =>
                getCities(
                    (returnFullOption && typeof employee_country === 'object'
                        ? employee_country?.value
                        : employee_country) as string
                ),
            enabled: !!employee_country,
        },
        {
            showLoading: false,
            showError: false,
        }
    )

    const { data: districts, isFetching: isFetchingDistrict } =
        useQueryWithHandler({
            queryKey: [QUERY_KEYS.DISTRICTS, formTitle, employee_city],
            queryFn: () =>
                getDitricts(
                    (returnFullOption && typeof employee_city === 'object'
                        ? employee_city?.value
                        : employee_city) as string
                ),
            enabled: !!employee_city,
        })

    const { data: wards, isFetching: isFetchingWard } = useQueryWithHandler(
        {
            queryKey: [QUERY_KEYS.WARDS, formTitle, employee_district],
            queryFn: () =>
                getWards({
                    state: (returnFullOption &&
                    typeof employee_city === 'object'
                        ? employee_city?.value
                        : employee_city) as string,
                    district: (returnFullOption &&
                    typeof employee_district === 'object'
                        ? employee_district?.value
                        : employee_district) as string,
                }),
            enabled: !!employee_district,
        },
        {
            showLoading: false,
            showError: false,
        }
    )

    return (
        <div className={`${padding && 'p-4'} rounded-[8px] bg-white`}>
            {formTitle && (
                <Typogaphy size="medium" className="font-semibold mb-4">
                    {t(formTitle)}
                </Typogaphy>
            )}

            <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
                {!country && (
                    <FormItem
                        allowClear={false}
                        control={control}
                        name={country_key}
                        type="select"
                        placeholder={t('country')}
                        label={t('country')}
                        options={countries}
                        returnFullOption={returnFullOption}
                        onChangeAfterHookForm={() => {
                            setValue(city_key || 'employee_city', '')
                            setValue(district_key || 'employee_district', '')
                            setValue(ward_key || 'employee_ward', '')
                        }}
                    />
                )}

                <FormItem
                    allowClear={false}
                    control={control}
                    name={city_key || 'employee_city'}
                    type="select"
                    placeholder={t('province')}
                    label={t('province')}
                    options={data || []}
                    disabled={!employee_country || isFetching}
                    loading={isFetching}
                    returnFullOption={returnFullOption}
                    onChangeAfterHookForm={() => {
                        setValue(district_key || 'employee_district', '')
                        setValue(ward_key || 'employee_ward', '')
                    }}
                />

                <FormItem
                    allowClear={false}
                    control={control}
                    name={district_key || 'employee_district'}
                    type="select"
                    placeholder={t('district')}
                    label={t('district')}
                    disabled={!employee_city || isFetchingDistrict}
                    options={districts || []}
                    loading={isFetchingDistrict}
                    returnFullOption={returnFullOption}
                    onChangeAfterHookForm={() => {
                        setValue(ward_key || 'employee_ward', '')
                    }}
                />

                <FormItem
                    allowClear={false}
                    control={control}
                    name={ward_key || 'employee_ward'}
                    type="select"
                    placeholder={t('ward')}
                    label={t('ward')}
                    disabled={!employee_district || isFetchingWard}
                    options={wards || []}
                    loading={isFetchingWard}
                    returnFullOption={returnFullOption}
                />

                <FormItem
                    allowClear={false}
                    control={control}
                    name={steet_key || 'employee_street'}
                    type="textfield"
                    placeholder={t('street')}
                    label={t('street')}
                    // disabled={!employee_country || employee_country !== 'VN'}
                    className="md:col-span-2"
                />
            </div>
        </div>
    )
}

export default PermanentAddress
